import { Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNotification } from "./contexts/notifications";
import { StatefulDialog } from "./statefulConfirmationDialog";
import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { stopAll } from "./lazerApi";
import { queryClient } from "../../api/queryClient";

const AllActionsButtons = () => {
  return (
    <Box display={"flex"} gap={1}>
      <StopAllButton />
    </Box>
  );
};

const StopAllButton = () => {
  const { addNotification } = useNotification();
  const msal = useMsal();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Box display={"flex"} flexDirection={"row"} gap={1}>
        <Button
          startIcon={<DeleteIcon />}
          variant="contained"
          onClick={() => setOpen(true)}
          color="error"
        >
          Delete all
        </Button>
      </Box>
      <StatefulDialog
        open={open}
        setOpen={setOpen}
        displayValues={{
          title: "Delete All Algos",
          body: "Are you sure you want to delete ALL LazerTrader algos?",
          loading: "Deleting all algos...",
          confirm: "Yes",
          cancel: "No",
        }}
        apiRequest={async () => {
          try {
            await stopAll(msal);
            queryClient.invalidateQueries({
              queryKey: ["v1/algos"],
            });
            addNotification("All algos stopped", "success");
          } catch (error) {
            addNotification("Failed to stop all algos: " + error, "error");
          }
        }}
      />
    </>
  );
};

export { AllActionsButtons };
